module.exports = __webpack_public_path__ + "img/lapp-kabel.8b000f2d.jpg";